import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CategoryTag } from '../common/ui';

/** A quote's categories as tags; with `max`, the rest collapse into "+n". */
export default function CategoryTags({ categories, max }) {
    const { t } = useTranslation();
    if (!categories?.length) return <Typography sx={{ fontSize: 12.5, color: '#CBD5E1' }}>{t('jobs.noCategory')}</Typography>;
    const shown = max ? categories.slice(0, max) : categories;
    const rest = categories.length - shown.length;
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
            {shown.map(c => <CategoryTag key={c.id} category={c} />)}
            {rest > 0 && (
                <Tooltip title={categories.slice(shown.length).map(c => c.name).join(', ')}>
                    <Typography component="span" sx={{ fontSize: 12, fontWeight: 700, color: '#64748B', px: 0.5 }}>+{rest}</Typography>
                </Tooltip>
            )}
        </Box>
    );
}
